import orderBy from 'lodash/orderBy'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useStore } from 'vuex'

import { groupAudits } from '../utils/audit-log-grouping'
import { UIState } from '@app/shared/constants'

import { useAuditsStore } from '../store/audits'

// TODO: Refactor to TS once the comms store is refactored to TS
export default function useAuditLogData() {
  const auditsStore = useAuditsStore()
  const {
    audits,
    changesSinceLastVisit,
    isFetchingAudits,
    uiStatus,
    hasMorePages,
    isFetchingMore,
  } = storeToRefs(auditsStore)

  const commsStore = useStore()

  const checks = computed(() => commsStore.getters.allChecks)
  const notes = computed(() => commsStore.getters.notes)
  const todos = computed(() => commsStore.getters.todos)
  const fetchingCommunicationsInProgress = computed(
    () => commsStore.getters.fetchingCommunicationsInProgress
  )

  const shouldShowChangesSinceLastVisit = computed(() => {
    if (changesSinceLastVisit.value.count <= 0) return false

    const since = changesSinceLastVisit.value.since
    const loadedAudits = audits.value

    if (loadedAudits.length === 0) return false

    const oldestLoadedTimestamp =
      loadedAudits[loadedAudits.length - 1]?.sortTimestamp
    return oldestLoadedTimestamp <= since || !hasMorePages.value
  })

  const effectiveAuditItems = computed(() => {
    const items = [
      ...audits.value,
      ...Object.values(checks.value || {}),
      ...Object.values(notes.value || {}),
      ...Object.values(todos.value || {}),
      shouldShowChangesSinceLastVisit.value
        ? {
            id: '0',
            sortTimestamp: changesSinceLastVisit.value.since,
            message: '',
            kind: 'changes-since-last-visit-line',
          }
        : null,
    ].filter((value) => !!value)

    const sortedItems = orderBy(items, 'sortTimestamp', 'desc')

    return groupAudits(sortedItems)
  })

  const isAnyFetchInProgress = computed(() => {
    return (
      uiStatus.value === UIState.LOADING ||
      fetchingCommunicationsInProgress.value
    )
  })

  return {
    auditItems: effectiveAuditItems,
    hasMorePages,
    isAnyFetchInProgress,
    isFetchingAudits,
    isFetchingMore,
  }
}
